exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input[data-v-26ff1bfb] {\n  border-color: #ced4da !important;\n  min-height: 38px !important;\n  color: #495057 !important;\n}", ""]);

// exports
